export default __webpack_public_path__ + "static/media/Spinner_Black.838e740b.svg";